import React from 'react';
import CustomPDFViewer from './CustomPDFViewer';

const WeeklyAd = () => {
  return (
        <CustomPDFViewer/>
  );
};

export default WeeklyAd;